module.exports = __webpack_public_path__ + "img/weddings_17_H.0f2d2589.webp";